<div
  *ngIf="state !== 'fresh'"
  class="freshness"
  [class.freshness--no-snapshot]="state === 'no_snapshot'"
  [class.freshness--stale]="state === 'stale'"
  [class.freshness--updating]="state === 'updating'"
  role="status"
  aria-live="polite"
  [title]="staleLimitsTooltip">
  <span class="freshness__dot" aria-hidden="true"></span>
  <span class="freshness__text">{{ label }}</span>
</div>
